/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, { useCallback, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { appendMetadataWithIndex } from 'ml-portals-util-react';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import '@xengage/gw-platform-translations';
import _ from 'lodash';
import metadata from './MLEditableCovTermMultipleOptComponent.metadata.json5';
import styles from './MLEditableCovTermMultipleOptComponent.module.scss';

function MLEditableCovTermMultipleOptComponent(props) {
    const {
        hasMultipleOptions,
        hasNoOptions,
        isYesNoOption,
        onCovChange,
        isModernProduct,
        coverage,
        term,
        covIndex,
        termIndex
    } = props;
    const { refreshData } = useDataRefresh();

    const formatOptionAvailableVals = useCallback((options) => {
        if (!options) return [];
        return options.map((opt) => ({
            code: opt.code,
            name: {
                id: opt.code,
                defaultMessage: opt.name
            }
        }));
    }, []);

const multipleOptionTermChanged = useCallback(
    (selectedOption, termParam) => {
        termParam.value = selectedOption;
        if(termParam?.codeIdentifier_ML != 'HOPIDShieldCov_ExtHOPCyberServicesAutoEnroll_Ext' && termParam?.codeIdentifier_ML != 'HOPCyberIDShieldCov_ExtHOPCyberServicesAndIdFraudExpenseAutoEnroll_Ext') {
            return;
        }
        if (termParam.applyNewValue) {
            termParam.applyNewValue();
        }

        if (onCovChange) {
            onCovChange(
                undefined,
                coverage?.code_ML,
                true,
                true
            );
        }
    },
    [onCovChange]
);

    const updateTermInput = () => {
        term.applyNewValue();
    };

    const setInputTermVal = (value) => {
        
        if (term?.name === 'Last 4 digits of SSN' && value?.length > 4) {         
            refreshData();
            return;
        }

        term.newValue = value;
        refreshData();
    }

    const resolvers = {
        resolveClassNameMap: styles
    };


    const overrides = {
        [`dateTerm${covIndex}${termIndex}`]: {
            visible: term.hasOptions && term.options.length === 0 && !term.readOnly,
            label: term.name,
            hideLabel: true
        },
        [`yesNoRadioButton${covIndex}${termIndex}`]: {
            value: term.value,
            availableValues: formatOptionAvailableVals(term.options),
            visible: isYesNoOption(term),
            onValueChange: multipleOptionTermChanged,
            onCovChange,
            path: term,
            label: term.name,
            hideLabel: true
        },
        [`selectContainer${covIndex}${termIndex}`]: {
            visible: hasMultipleOptions(term) && !isYesNoOption(term) && term.isEditable_ML,
            label: term.name,
            hideLabel: true
        },
        [`termSelect${covIndex}${termIndex}`]: {
            value: term.value,
            availableValues: formatOptionAvailableVals(term.options),
            onValueChange: multipleOptionTermChanged,
            path: term,
            label: term.name,
            hideLabel: true
        },
        [`inputNonReadonly${covIndex}${termIndex}`]: {
            visible: hasNoOptions(term),
            value: term.newValue,
            onValueChange: setInputTermVal,
            onBlur: updateTermInput,
            path: term,
            disabled: !term.isEditable_ML,
            label: term.name,
            hideLabel: true
        }
    };

    const updatedMetadata = appendMetadataWithIndex(metadata.componentContent, `${covIndex}${termIndex}`);

    return <MetadataContent uiProps={updatedMetadata} overrideProps={overrides} {...resolvers} />;
}

MLEditableCovTermMultipleOptComponent.propTypes = {
    editMode: PropTypes.bool,
    getChosenTermValue: PropTypes.func,
    hasSingleOption: PropTypes.func,
    getSingleOption: PropTypes.func,
    isYesNoOption: PropTypes.func,
    hasMultipleOptions: PropTypes.func,
    hasNoOptions: PropTypes.func,
    term: PropTypes.shape({}),
    covIndex: PropTypes.number,
    termIndex: PropTypes.number,
    onCovChange: PropTypes.func
    
};

export default MLEditableCovTermMultipleOptComponent;
